import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Link,
  Divider,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

const TermsOfUse = () => {
  return (
    <Box sx={{ backgroundColor: '#EFDDD0', minHeight: '100vh' }}>
  <Container maxWidth="md" sx={{ py: 4, backgroundColor: "#EFDDD0" }}>
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center" color='#EF7F95'>
        Terms of Use
      </Typography>

      <Typography variant="subtitle1" color="text.secondary" align="center" paragraph>
        Last Updated: {new Date().toLocaleDateString()}
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          1. Service Description
        </Typography>
        <Typography paragraph>
          COCO Excel provides online Excel courses and AI tools ("Services"). After completing payment via PayPal,
          access will be sent to the registered email. By using this website, you agree to these Terms of Use.
          We reserve the right to modify or update the Terms at any time without notice. Continued use constitutes acceptance.
          You should regularly review the Terms for changes.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          2. User Eligibility
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Users must be at least 18 years old." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Account sharing is prohibited. Each account is for individual use only." />
          </ListItem>
        </List>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          3. Payment and Refunds
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Payments are processed through PayPal and may be affected by currency exchange rates." />
          </ListItem>
          <ListItem>
            <ListItemText primary="All payments are non-refundable once completed." />
          </ListItem>
          <ListItem>
            <ListItemText primary="For disputes, contact PayPal or COCO Excel support." />
          </ListItem>
        </List>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          4. User Conduct
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Do not attempt to hack or reverse-engineer the tools or course content." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Do not resell, share accounts, or redistribute course materials." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Do not abuse the service (e.g., automated data scraping)." />
          </ListItem>
        </List>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          5. Intellectual Property
        </Typography>
        <Typography paragraph>
          All course videos, materials, and AI tool code are the property of COCO Excel.
          Users are granted limited usage rights and may not copy, distribute, or use them for commercial purposes.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          6. Disclaimer
        </Typography>
        <Typography paragraph>
          We do not guarantee that the courses or tools will meet every user’s needs.
          We are not liable for any data loss or business risks resulting from using Excel or our tools.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          7. Service Changes and Termination
        </Typography>
        <Typography paragraph>
          COCO Excel may modify course content, pricing, or discontinue services at any time with prior notice.
          We reserve the right to suspend or terminate accounts that violate these Terms.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          8. Governing Law and Dispute Resolution
        </Typography>
        <Typography paragraph>
          These Terms are governed by the laws of the United Kingdom, without regard to conflict of law principles.
          In case of disputes, both parties agree to attempt amicable resolution first.
          If unresolved, the matter shall be submitted to local arbitration body for binding arbitration.
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          9. Contact Information
        </Typography>
        <Typography paragraph>
          If you have any questions about these Terms, please contact us at:
        </Typography>
        <Link href="mailto:helper@mindlink.work" color="primary">
          helper@mindlink.work
        </Link>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Typography variant="body2" color="text.secondary" align="center">
        © {new Date().getFullYear()} COCO Excel. All rights reserved.
      </Typography>
    </Paper>
  </Container>
</Box>
//     <Box sx={{ backgroundColor: '#EFDDD0', minHeight: '100vh' }}>
//     <Container maxWidth="md" sx={{ py: 4, backgroundColor: "#EFDDD0" }}>
//       <Paper elevation={3} sx={{ p: 4 }}>
//         <Typography variant="h3" component="h1" gutterBottom align="center" color='#EF7F95'>
//           Terms of Use（使用条款）
//         </Typography>
  
//         <Typography variant="subtitle1" color="text.secondary" align="center" paragraph>
//           最近更新：{new Date().toLocaleDateString()}
//         </Typography>
  
//         <Divider sx={{ my: 3 }} />
  
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom>
//             1. 服务描述
//           </Typography>
//           <Typography paragraph>
//             COCO Excel 提供在线 Excel 课程和 AI 工具服务（以下简称“服务”）。用户通过 PayPal 完成支付后，课程或工具访问权限将通过电子邮件发送至用户注册邮箱。使用本网站即表示您接受并同意本使用条款。我们保留随时修改、更新本网站和条款的权利，恕不另行通知。若您不同意本条款的任何部分，请勿使用本网站。继续使用即视为您接受所有修改内容。建议您定期查看本条款。
//           </Typography>
//         </Box>
  
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom>
//             2. 用户资格
//           </Typography>
//           <Typography paragraph>
//             用户需年满 16 岁。
//           </Typography>
//           <Typography paragraph>
//             禁止共享账户，每个账户仅限个人使用。
//           </Typography> 
//         </Box>
  
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom>
//             3. 付款与退款
//           </Typography>
//           <Typography paragraph>
//             通过 PayPal 支付，价格以美元（或其他货币）显示，可能受汇率影响。
//           </Typography> 
//           <Typography paragraph>
//             所有通过 PayPal 支付的课程和工具服务，一经付款，概不退款。
//           </Typography> 
//           <Typography paragraph>
//             若有支付争议，请联系 PayPal 或 COCO Excel 客服。 
//           </Typography> 
//         </Box>
  
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom>
//             4. 用户行为规范
//           </Typography>
//           <Typography paragraph>
//             禁止破解、逆向工程 AI 工具或课程内容。
//           </Typography> 
//           <Typography paragraph>
//             禁止转售、共享账户或传播课程材料。
//           </Typography> 
//           <Typography paragraph>
//             禁止滥用服务，例如自动化爬取数据。
//           </Typography> 
//         </Box>
  
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom>
//             5. 知识产权
//           </Typography>
//           <Typography paragraph>
//             所有课程视频、教材、AI 工具代码均归 COCO Excel 所有。用户仅获得有限使用权，禁止复制、分发或用于任何商业用途。
//           </Typography>
//         </Box>
  
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom>
//             6. 免责声明
//           </Typography>
//           <Typography paragraph>
//             我们不保证课程或工具能满足所有用户的需求。因使用 Excel 或相关工具所导致的数据丢失或业务风险，我们不承担任何责任。
//           </Typography>
//         </Box>
  
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom>
//             7. 服务变更与终止
//           </Typography>
//           <Typography paragraph>
//             COCO Excel 有权在任何时间调整课程内容、价格或终止服务，届时将提前通知用户。如用户违反使用条款，我们有权暂停或终止其账户。
//           </Typography>
//         </Box>
  
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom>
//             8. 适用法律与争议解决
//           </Typography>
//           <Typography paragraph>
//             本使用条款受英国法律管辖并依其解释，不适用其法律冲突原则。若发生争议，双方应首先通过友好协商解决。如协商无效，争议应提交
//             当地仲裁机构并依据其仲裁规则进行仲裁，裁决具有终局性和约束力。
//           </Typography>
//         </Box>
  
//         <Box sx={{ mb: 2 }}>
//           <Typography variant="h5" component="h2" gutterBottom>
//             9. 联系方式
//           </Typography>
//           <Typography paragraph>
//             如对本条款有任何疑问，请通过以下方式联系我们：
//           </Typography>
//           <Link href="mailto:support@cocoexcel.com" color="primary">
//             support@cocoexcel.com
//           </Link>
//         </Box>
  
//         <Divider sx={{ my: 3 }} />
  
//         <Typography variant="body2" color="text.secondary" align="center">
//           © {new Date().getFullYear()} COCO Excel 版权所有。
//         </Typography>
//       </Paper>
//     </Container>
//   </Box>
   
  );
};

export default TermsOfUse;